import { GET_CALCULATOR } from '../../constants/ActionTypes';

const initialState = {
  items: [],
  loaded: false,
  loading: false,
  error: null,
};

export default function calculator(state = initialState, action = {}) {
  switch (action.type) {
    case `${GET_CALCULATOR}_PENDING`:
      return {
        ...state,
        error: null,
        loaded: false,
        loading: true,
      };
    case `${GET_CALCULATOR}_SUCCESS`:
      return {
        ...state,
        result: structuredClone(action.result?.calculator),
        error: null,
        loaded: true,
        loading: false,
      };
    case `${GET_CALCULATOR}_FAIL`:
      return {
        ...state,
        error: action.error,
        loaded: false,
        loading: false,
      };
    default:
      return state;
  }
}
